import { GET_PROVIDER_BY_COMPETENCY, GET_TRAINING_BY_PROVIDER, GET_TRAINING_PROVIDER } from "@/api/master-data/training-provider/training-provider";
import queryString from "query-string";

const state = {
    trainingProviders: [],
    trainingByProvider: [],
    trainingByProviderByCompetency: [],
};
const mutations = {
    setTrainingProviders: (states, payload) => {
        states.trainingProviders = payload;
    },
    setTrainingByProvider: (state, payload) => {
        state.trainingByProvider = payload;
    },
    setProviderByCompetency: (state, payload) => {
        state.trainingByProviderByCompetency = payload;
    },
};
const actions = {
    getTrainingProviders: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_TRAINING_PROVIDER(params);
            if (resp.data.httpCode === 200) {
                commit("setTrainingProviders", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setTrainingProviders", []);
            }
            throw err;
        }
    },
    getTrainingByProvider: async ({ commit }, { providerId, search }) => {
        const params = {search};

        try {
            const resp = await GET_TRAINING_BY_PROVIDER(providerId, params);
            if (resp.data.httpCode === 200) {
                commit("setTrainingByProvider", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setTrainingByProvider", []);
            }
            throw err;
        }
    },

    getProviderByCompentency: async ({ commit }, competency) => {
        try {
            const resp = await GET_PROVIDER_BY_COMPETENCY(competency);
            if (resp.data.httpCode === 200) {
                commit("setProviderByCompetency", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProviderByCompetency", []);
            }
            throw err;
        }
    },
};

const getters = {
    trainingProviders: (states) => states.trainingProviders,
    trainingByProvider: (state) => state.trainingByProvider,
    trainingByProviderByCompetency: (state) => state.trainingByProviderByCompetency,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
